<section class="contact section" id="contact">
  <h2 class="section__title">Contact Me</h2>
  <span class="section__subtitle">Get in touch</span>

  <div class="contact__container container grid">
    <div>
      <div class="contact__information">
        <i class="uil uil-phone contact__icon"></i>

        <div>
          <h3 class="contact__title">Call me</h3>
          <span class="contact__subtitle">??? - ??? - ???</span>
        </div>
      </div>

      <div class="contact__information">
        <i class="uil uil-envelope contact__icon"></i>

        <div>
          <h3 class="contact__title">Email</h3>
          <span class="contact__subtitle">giovanni9972@libero.it</span>
        </div>
      </div>

      <div class="contact__information">
        <i class="uil uil-map-marker contact__icon"></i>

        <div>
          <h3 class="contact__title">Location</h3>
          <span class="contact__subtitle">?? ?? ??</span>
        </div>
      </div>
    </div>

    <form [formGroup]="FormData" class="contact__form grid">
      <div class="contact__inputs grid">
        <div class="contact__content">
          <label class="contact__label">Name</label>
          <input type="text" class="contact__input" name="name" formControlName="name">
        </div>

        <div class="contact__content">
          <label class="contact__label">Email</label>
          <input type="email" class="contact__input" name="email" formControlName="email">
        </div>
      </div>

      <div class="contact__content">
        <label class="contact__label">Project</label>
        <input type="text" class="contact__input" name="project" formControlName="project">
      </div>
      <div class="contact__content">
        <label class="contact__label">Message</label>
        <textarea cols="30" rows="7" class="contact__input" name="comment"
          formControlName="comment"></textarea>
      </div>

      <div>
        <a class="button button--flex " (click)="onSubmit(FormData.value)">
          Send Message
          <i class="uil uil-message button__icon"></i>
        </a>
      </div>
    </form>
  </div>
</section>
